import { NgModule } from '@angular/core';
import {
  DfAdvancedInputModule,
  DfAlertModule,
  DfProgressbarModule,
  DfSelectModule
} from "@design-factory/design-factory";


@NgModule({
  exports: [
    DfAdvancedInputModule,
    DfAlertModule,
    DfSelectModule,
    DfProgressbarModule
  ],
})
export class DesignFactoryModule { }
